"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var sumBy_1 = __importDefault(require("lodash/sumBy"));
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var redux_1 = require("redux");
var NavTabs_1 = __importDefault(require("atomicComponents/atoms/NavTabs/NavTabs"));
var NavTabsContainer_1 = __importDefault(require("atomicComponents/atoms/NavTabs/NavTabsContainer"));
var Table_1 = __importDefault(require("atomicComponents/atoms/Table/Table"));
var TableBody_1 = __importDefault(require("atomicComponents/atoms/Table/TableBody"));
var hooks_1 = require("atomicComponents/organisms/SortableHeader/hooks");
var SortHoC_1 = __importDefault(require("atomicComponents/organisms/SortableHeader/SortHoC"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var HoCs_1 = require("utils/HoCs");
var ordered_1 = require("utils/selectors/ordered");
var other_1 = require("utils/selectors/other");
var populatedDerived_1 = require("utils/selectors/populatedDerived");
var AddTeam_1 = __importDefault(require("./AddTeam"));
var hooks_2 = require("./hooks");
var NoTeamRowDetails_1 = __importDefault(require("./NoTeamRowDetails"));
var TeamPreview_1 = __importDefault(require("./TeamPreview"));
var TeamsHeader_1 = __importDefault(require("./TeamsHeader"));
var TeamsRow_1 = __importDefault(require("./TeamsRow"));
var TeamsTableFooter_1 = __importDefault(require("./TeamsTableFooter"));
var TeamsTableMenu_1 = __importDefault(require("./TeamsTableMenu"));
var TeamView = function () {
    var teamTabs = [
        { label: 'Teams', href: '/teams' },
    ];
    var singleTeamViewTabs = [
        { label: 'Teams', href: '/teams' },
        { label: 'close preview' },
    ];
    var getTeamStats = (0, hooks_2.useGetToolCountAndSpend)();
    var sStatsTeamData = (0, react_redux_1.useSelector)(other_1.selectServiceStatsTeamData);
    var serviceStats = (0, react_redux_1.useSelector)(populatedDerived_1.selectPopulatedServiceStats);
    var teams = (0, react_redux_1.useSelector)(ordered_1.selectCompanyTeams);
    var _a = __read((0, react_1.useState)(null), 2), selectedTeamId = _a[0], setSelectedTeamId = _a[1];
    var selectedTeam = react_1.default.useMemo(function () { return selectedTeamId && (teams === null || teams === void 0 ? void 0 : teams.find(function (t) { return t.id === selectedTeamId; })); }, [selectedTeamId, teams]);
    var _b = __read((0, react_1.useState)(false), 2), addTeam = _b[0], setAddTeam = _b[1];
    var sortedTeams = (0, hooks_1.useSortArray)(teams, {
        spend: function (team) { return getTeamStats(team).spend; },
        toolCount: function (team) { return getTeamStats(team).serviceStats.length; },
    });
    if (!(0, react_redux_firebase_1.isLoaded)(serviceStats) || !(0, react_redux_firebase_1.isLoaded)(teams)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    var noTeamServiceStats = sStatsTeamData === null || sStatsTeamData === void 0 ? void 0 : sStatsTeamData.noTeamSStats;
    var noTeamSpend = (0, sumBy_1.default)(noTeamServiceStats, 'calculatedAnnualSpend');
    var noTeamTools = noTeamServiceStats === null || noTeamServiceStats === void 0 ? void 0 : noTeamServiceStats.length;
    var totalTeams = (sortedTeams === null || sortedTeams === void 0 ? void 0 : sortedTeams.length) || 0;
    var totalSpend = (0, sumBy_1.default)(serviceStats, 'calculatedAnnualSpend');
    var totalHeadcount = (0, sumBy_1.default)(sortedTeams, function (item) { return Number(item.headcount); });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Hudled - Teams", description: "List of Teams" }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", overflow: "auto", height: "100%" }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ width: selectedTeamId ? '350px' : '100%', display: "flex", flexDirection: "column" }, { children: [(0, jsx_runtime_1.jsx)(NavTabsContainer_1.default, __assign({ maxWidth: 920 }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ flex: "1" }, { children: [(0, jsx_runtime_1.jsx)(NavTabs_1.default, { tabs: selectedTeamId ? singleTeamViewTabs : teamTabs, onClick: function () { return setSelectedTeamId(null); } }), !selectedTeamId && (0, jsx_runtime_1.jsx)(TeamsTableMenu_1.default, { setAddTeam: setAddTeam })] })) })), (0, jsx_runtime_1.jsxs)(Table_1.default, __assign({ maxWidth: 920 }, { children: [(0, jsx_runtime_1.jsx)(TeamsHeader_1.default, { selectedServiceStat: !!selectedTeamId }), (0, jsx_runtime_1.jsxs)(TableBody_1.default, __assign({ pl: 2.5 }, { children: [addTeam && ((0, jsx_runtime_1.jsx)(AddTeam_1.default, { setAddTeam: setAddTeam, isPartialView: !!selectedTeamId })), sortedTeams === null || sortedTeams === void 0 ? void 0 : sortedTeams.map(function (team) { return ((0, jsx_runtime_1.jsx)(TeamsRow_1.default, { item: team, onClickRow: function (selectedItem) { return setSelectedTeamId((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) || null); }, selectedItem: selectedTeam }, team.id)); }), (0, jsx_runtime_1.jsx)(NoTeamRowDetails_1.default, { spend: noTeamSpend, toolsCount: noTeamTools, isPartialView: !!selectedTeamId })] })), (0, jsx_runtime_1.jsx)(TeamsTableFooter_1.default, { totalHeadcount: totalHeadcount, totalTeams: totalTeams, totalSpend: totalSpend, isHidden: !!selectedTeamId })] }))] })), selectedTeamId && ((0, jsx_runtime_1.jsx)(TeamPreview_1.default, { team: selectedTeam, onClickClose: function () { return setSelectedTeamId(null); } }, selectedTeamId))] }))] }));
};
exports.default = (0, redux_1.compose)(HoCs_1.HasCompanyHoC, react_1.default.memo, function (Component) { return (0, SortHoC_1.default)(Component, { key: 'serviceName', order: 1 }); })(TeamView);
